module.exports = __webpack_public_path__ + "img/main_logo.39bf51d2.png";